import React from "react";
import { newTacticPrimaryRepository } from "@/repositories/tacticPrimary";
import { Head } from "@/components/base/Head";
import Image from "next/image";
import { TacticSimpleCard } from "@/components/base/ui/TacticSimpleCard";
import { Breadcrumb } from "@/components/base/Breadcrumb";
import { client } from "@/api/client";
import { TacticPrimary } from "@/types/tacticPrimary";

const TacticPrimaryPage = ({
  tacticPrimary,
}: {
  tacticPrimary: TacticPrimary;
}) => {
  const META_TITLE = `${tacticPrimary?.name_ja}`;
  const breadcrumbs = [
    {
      title: "講座一覧",
      slug: "/tactics",
    },
    {
      title: META_TITLE,
    },
  ];

  return (
    <>
      <Head title={META_TITLE} />
      <main className={"pb-20"}>
        <div className={"mb-10 max-w-[1440px] m-auto px-4 py-2"}>
          <Breadcrumb breadcrumbs={breadcrumbs} />
        </div>
        <div className={"px-4 lg:px-12 pt-5 pb-10"}>
          <div className="lg:flex items-start">
            <div
              className={
                "text-center border-b border-[#ccc] md:border-none mb-7 pb-7 lg:mb-0 lg:pb-0"
              }
            >
              <div className={"inline-block shadow-lg leading-[0]"}>
                {tacticPrimary?.image && (
                  <Image
                    src={tacticPrimary?.image}
                    width={250}
                    height={349}
                    alt={tacticPrimary?.name_ja}
                  />
                )}
              </div>
            </div>
            <div className={"flex-1 lg:pl-10"}>
              {tacticPrimary?.tactics?.map((tactic, index) => (
                <div key={index}>
                  <TacticSimpleCard tactic={tactic} />
                </div>
              ))}
            </div>
          </div>
        </div>
      </main>
    </>
  );
};

export async function getStaticPaths() {
  const tacticPrimariesRepository = newTacticPrimaryRepository(client);
  const response = await tacticPrimariesRepository.listTacticPrimaries();
  const paths = response.map((content) => ({
    params: { id: content.id },
  }));
  return { paths, fallback: false };
}
export async function getStaticProps(context: { params: { id: string } }) {
  const tacticPrimariesRepository = newTacticPrimaryRepository(client);
  try {
    const response = await tacticPrimariesRepository.getTacticPrimary(
      context.params.id as string
    );

    return {
      props: {
        tacticPrimary: response,
      },
    };
  } catch (e) {
    return {
      redirect: {
        destination: `/404`,
        permanent: false,
      },
    };
  }
}
export default TacticPrimaryPage;
